import * as configService from '@services/config-service';
import * as resendSendInvitationService from '@services/resend-invitation-service';
import { showError } from '@store/logged/actions';
import * as configTypes from './actionTypes';

export const setConfig = (config) => ({
  type: configTypes.SET_CONFIG,
  payload: config,
});

export const fetchConfig = () => (dispatch) =>
  configService
    .fetchConfig()
    .then((response) => dispatch(setConfig(response)))
    .catch((error) => dispatch(showError(error)));

export const successSend = () => ({
  type: configTypes.SUCCESS_RESEND,
});

export const resendSendInvitation = () => (dispatch) =>
  resendSendInvitationService
    .resendInvitation()
    .then((response) => dispatch(successSend(response)))
    .catch((error) => dispatch(showError(error)));
